// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./zz.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".titleLine-1PkSkm4K {\n    width: 100%;\n    height: 60px;\n    line-height: 60px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    text-align: center;\n    color: #fff;\n    font-size: 28px;\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n    background-repeat: repeat-x;\n    background-size: 100% 60px;\n    -webkit-transition: all 0.5s;\n    transition: all 0.5s;\n}\n\n.titleLineHide-T9_U-GHI {\n    top: -50px;\n}\n", ""]);
// Exports
exports.locals = {
	"titleLine": "titleLine-1PkSkm4K",
	"titleLineHide": "titleLineHide-T9_U-GHI"
};
module.exports = exports;
